import { useState, type JSX } from 'react';

import { useAuthStore } from '../../state/auth.js';

/**
 * Floating user menu — top-right of the viewport. Shows the current user's
 * username with an Audi-monochrome dropdown ("Admin Panel" for admins,
 * "Sign out").
 */
export function UserMenu(): JSX.Element | null {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const [open, setOpen] = useState(false);

  if (user === null) return null;

  return (
    <div className="relative">
      <button
        type="button"
        data-testid="user-menu-trigger"
        onClick={() => setOpen((v) => !v)}
        className="hover:bg-audi-red rounded-none border border-white/25 bg-transparent px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-white transition-colors hover:border-transparent"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        {user.username}
        <span className="ml-1 text-white/60">▾</span>
      </button>
      {open ? (
        <div
          role="menu"
          className="bg-cream-50 border-taupe-500 absolute right-0 mt-1 w-48 overflow-hidden rounded-none border text-sm"
        >
          {user.role === 'admin' ? (
            <a
              role="menuitem"
              href="#admin"
              onClick={() => setOpen(false)}
              className="text-fg hover:bg-cream-100 hover:text-audi-red block px-3 py-2"
            >
              User management
            </a>
          ) : null}
          <a
            role="menuitem"
            href="#account"
            onClick={() => setOpen(false)}
            className="text-fg hover:bg-cream-100 hover:text-audi-red block px-3 py-2"
          >
            Change password
          </a>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              void logout();
            }}
            className="text-fg hover:bg-cream-100 hover:text-audi-red block w-full px-3 py-2 text-left"
          >
            Sign out
          </button>
        </div>
      ) : null}
    </div>
  );
}
